// extracted by mini-css-extract-plugin
export default {"box":"AgentForm_box__F48oE","textArea":"AgentForm_textArea__HdHcx"};